import Quill from 'quill';

const BlockEmbed = Quill.import('blots/block/embed');

class SelloBlot extends BlockEmbed {
  static create(value) {
    const node = super.create();
    const selloContainer = document.createElement('div');
    selloContainer.style.cssText = `
      border: 1px solid #3165bb;
      color: #3165bb;
      font-size: 9px;
      font-family: Arial;
      text-align: center;
      padding: 2px 0px;
      display: inline-block;
      line-height: 1.1;
      width: 130px;
    `;
    selloContainer.innerHTML = `
      <strong>DEPARTAMENTO DE EDUCACIÓN<br>
      <u>APROBADO</u></strong><br><br>
      <strong>${value?.fecha}</strong><br>
      <strong>${value?.codigo}</strong><br><br>
      <strong>UNIDAD DE QUERELLAS<br>Y REMEDIO PROVISIONAL</strong>
    `;
    node.appendChild(selloContainer);
    if (value) {
      node.setAttribute('data-sello', JSON.stringify(value));
    }
    return node;
  }

  static value(node) {
    const data = node.getAttribute('data-sello');
    if (data) {
      try {
        return JSON.parse(data);
      } catch (e) {
        return {
          fecha: '{{Fecha Sello}}',
          codigo: '{{Número de Contrato}}',
        };
      }
    }
    return {
      fecha: '{{Fecha Sello}}',
      codigo: '{{Número de Contrato}}',
    };
  }

  static formats(node) {
    const data = node.getAttribute('data-sello');
    if (data) {
      try {
        return JSON.parse(data);
      } catch (e) {
        return null;
      }
    }
    return null;
  }
}

SelloBlot.blotName = 'sello';
SelloBlot.tagName = 'div';
SelloBlot.className = 'custom-sello';

Quill.register(SelloBlot);

export function addSelloHandler(quill) {
  const toolbar = quill.getModule('toolbar');

  if (toolbar) {
    toolbar.addHandler('sello', function() {
      const range = quill.getSelection(true);
      if (!range) return;
      quill.insertEmbed(
        range.index,
        'sello',
        {
          fecha: '{{Fecha Sello}}',
          codigo: '{{Número de Contrato}}',
        },
        'user'
      );
      quill.setSelection(range.index + 1, 'silent');
    });
  }
}

export default SelloBlot;
